import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	TextField
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { State } from '../../reducers';
import { closeDeclineDialog, changeDeclineComment, decline } from '../actions';
import { useDispatch, useSelector } from 'react-redux';

const useStyles = makeStyles((theme) => ({
	width: {
		width: theme.spacing(50)
	}
}));

export function DeclineDialog() {
	const classes = useStyles({});
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const { open, comment, isProcessing } = useSelector((state: State) => ({
		open: state.orders.single.declineDialog.open,
		comment: state.orders.single.declineDialog.comment,
		isProcessing: state.orders.single.declineDialog.isProcessing
	}));
	return (
		<Dialog open={open} classes={{ paper: classes.width }}>
			<DialogTitle>{t('orders:dialog_decline_title')}</DialogTitle>
			<DialogContent>
				<TextField
					id="order_decline_dialog_field_comment"
					data-testid="order-decline-comment-input"
					value={comment}
					onChange={(e) => dispatch(changeDeclineComment(e.target.value))}
					label={t('orders:dialog_decline_reason')}
					multiline
					rows={3}
					error={!comment}
					maxRows={5}
					fullWidth
					variant="standard"
				/>
			</DialogContent>
			<DialogActions>
				<Button variant="text" color="secondary" onClick={() => dispatch(closeDeclineDialog())}>
					{t('general:cta_cancel')}
				</Button>
				<Button
					id="order_decline_dialog_button_submit"
					data-testid="order-decline-submit-button"
					color="primary"
					disabled={!comment || isProcessing}
					onClick={() => dispatch(decline())}
				>
					{t('orders:cta_decline')}
				</Button>
			</DialogActions>
		</Dialog>
	);
}
